export function convertStringToCssVariable(name: string): string {
    if (typeof name === 'string' && name.includes('var(')) {
        return window
            .getComputedStyle(document.documentElement)
            .getPropertyValue(name.replace('var(', '').replace(')', ''));
    }

    return name;
}
